import { monthsYearsFormatter } from '@services/months-years-formatter';

import { usePhrases } from './context/usePhrases';

export const useMonthsYearsFormatter = () => {
  const { month, months, year, years } = usePhrases({ name: 'units' });

  return { monthsYearsFormatter: monthsYearsFormatter({ month, months, year, years }) };
};
